import styled from 'styled-components';

type Props = {
  $color: string;
  $borderColor: string;
};

export const StyledTag = styled.div<Props>`
  width: fit-content;
  border: ${({ $borderColor }) => `1px solid ${$borderColor}`};
  padding: 2px 6px;
  background-color: ${({ $color }) => $color};
  border-radius: 4px;
  display: flex;
  align-items: center;
`;

export const TextWrapper = styled.div<Pick<Props, '$color'>>`
  color: ${({ $color }) => $color};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;
